// extracted by mini-css-extract-plugin
module.exports = {"svg":"breakdown-2-module--svg--J4s5w"};